<template>
  <v-dialog v-model="visible" max-width="500px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="form.nombre"
                label="Tipo Programa"
                outlined
                dense
                hide-details
                clearable></v-text-field>

              <small v-for="error in errores.nombre" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="form.abreviacionEmpastado"
                label="Abreviación (Empastado)"
                outlined
                dense
                hide-details
                clearable></v-text-field>

              <small v-for="error in errores.abreviacionEmpastado" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text :disabled="enviando" @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :disabled="enviando"
          :loading="enviando"
          @click.prevent="() => validar(registrar, editar)">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import modalFormMixin from '../mixins/modal-form.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import CategoriaUniversidadService from '../services/categoria-universidad.service';

export default {
  name: 'ModalFormularioCategoriaUniversidad',
  mixins: [modalFormMixin, apiConsumerMixin],
  props: {
    universidadId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      conceptos: [],
    };
  },
  watch: {
    'form.nombre': function () {
      this.errores.nombre = [];
    },
    'form.abreviacionEmpastado': function () {
      this.errores.abreviacionEmpastado = [];
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        nombre: null,
        abreviacionEmpastado: null,
        universidadId: this.universidadId,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        nombre: data.nombre,
        abreviacionEmpastado: data.abreviacionEmpastado,
        universidadId: data.universidadId,
      };
    },
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
    },
    guardar(accion) {
      this.guardarDatosMixin(
        CategoriaUniversidadService.create,
        CategoriaUniversidadService.update,
        accion,
        this.form,
        this.nombreRecurso,
        () => {
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          this.errores = errores;
        },
      );
    },
    registrar() {
      this.guardar(this.accionesCrud.REGISTRAR);
    },
    editar() {
      this.guardar(this.accionesCrud.EDITAR);
    },
  },
};
</script>